import {
  POLLUTIONSOURCELIST
} from '../actions/pollutionSource';

import {reducerPackage} from "../../utils";

export const pollutionSourceList = reducerPackage(POLLUTIONSOURCELIST);

